import { render, staticRenderFns } from "./DisplaySplitUnitCode.vue?vue&type=template&id=05e17b71&scoped=true&"
import script from "./DisplaySplitUnitCode.vue?vue&type=script&lang=ts&"
export * from "./DisplaySplitUnitCode.vue?vue&type=script&lang=ts&"
import style0 from "./DisplaySplitUnitCode.vue?vue&type=style&index=0&id=05e17b71&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e17b71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e17b71')) {
      api.createRecord('05e17b71', component.options)
    } else {
      api.reload('05e17b71', component.options)
    }
    module.hot.accept("./DisplaySplitUnitCode.vue?vue&type=template&id=05e17b71&scoped=true&", function () {
      api.rerender('05e17b71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Leasing/DisplaySplitUnitCode.vue"
export default component.exports